
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch } from 'vue'

import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
// import func from "vue-temp/vue-editor-bridge";
const myColumns: any = {
  ybqy: [
    {
      title: '资产负债表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '流动资产',
      dataIndex: '',
      key: ''
    },
    {
      title: '货币资金',
      dataIndex: 'CashEquivalents',
      key: 'CashEquivalents',
      indentStep: 1
    },
    {
      title: '交易性金融资产',
      dataIndex: 'TradingAssets',
      key: 'TradingAssets',
      indentStep: 1
    },
    {
      title: '衍生金融资产',
      dataIndex: 'DerivativeAssets',
      key: 'DerivativeAssets',
      indentStep: 1
    },
    {
      title: '应收票据及应收账款',
      dataIndex: 'BillAccReceivable',
      key: 'BillAccReceivable',
      indentStep: 1
    },
    {
      title: '其中:应收票据',
      dataIndex: 'BillReceivable',
      key: 'BillReceivable',
      indentStep: 1
    },
    {
      title: '应收账款',
      dataIndex: 'AccountReceivable',
      key: 'AccountReceivable',
      indentStep: 2
    },
    {
      title: '应收款项融资',
      dataIndex: 'ReceivablesFin',
      key: 'ReceivablesFin',
      indentStep: 1
    },
    {
      title: '预付款项',
      dataIndex: 'AdvancePayment',
      key: 'AdvancePayment',
      indentStep: 1
    },
    {
      title: '其他应收款合计',
      dataIndex: 'OtherReceivableED',
      key: 'OtherReceivableED',
      indentStep: 1
    },
    {
      title: '其中:应收利息',
      dataIndex: 'InterestReceivable',
      key: 'InterestReceivable',
      indentStep: 1
    },
    {
      title: '存货',
      dataIndex: 'Inventories',
      key: 'Inventories',
      indentStep: 1
    },
    {
      title: '其他流动资产',
      dataIndex: 'OtherCurrentAssets',
      key: 'OtherCurrentAssets',
      indentStep: 1
    },
    {
      title: '流动资产合计',
      dataIndex: 'TotalCurrentAssets',
      key: 'TotalCurrentAssets'
    },
    {
      title: '非流动资产',
      dataIndex: '',
      key: ''
    },
    {
      title: '长期股权投资',
      dataIndex: 'LongtermEquityInvest',
      key: 'LongtermEquityInvest',
      indentStep: 1
    },
    {
      title: '其他权益工具投资',
      dataIndex: 'OthEquityInstrument',
      key: 'OthEquityInstrument',
      indentStep: 1
    },
    {
      title: '投资性房地产',
      dataIndex: 'InvestmentProperty',
      key: 'InvestmentProperty',
      indentStep: 1
    },
    {
      title: '固定资产',
      dataIndex: 'FixedAssets',
      key: 'FixedAssets',
      indentStep: 1
    },
    {
      title: '在建工程',
      dataIndex: 'ConstruInProcess',
      key: 'ConstruInProcess',
      indentStep: 1
    },
    {
      title: '无形资产',
      dataIndex: 'IntangibleAssets',
      key: 'IntangibleAssets',
      indentStep: 1
    },
    {
      title: '长期待摊费用',
      dataIndex: 'LongDeferredExpense',
      key: 'LongDeferredExpense',
      indentStep: 1
    },
    {
      title: '递延所得税资产',
      dataIndex: 'DeferredTaxAssets',
      key: 'DeferredTaxAssets',
      indentStep: 1
    },
    {
      title: '其他非流动资产',
      dataIndex: 'OtherNonCurrentAssets',
      key: 'OtherNonCurrentAssets',
      indentStep: 1
    },
    {
      title: '非流动资产合计',
      dataIndex: 'TotalNonCurrentAssets',
      key: 'TotalNonCurrentAssets'
    },
    {
      title: '资产总计',
      dataIndex: 'TotalAssets',
      key: 'TotalAssets'
    },
    {
      title: '流动负债',
      dataIndex: '',
      key: ''
    },
    {
      title: '短期借款',
      dataIndex: 'ShortTermLoan',
      key: 'ShortTermLoan',
      indentStep: 1
    },
    {
      title: '应付票据及应付账款',
      dataIndex: 'NotAccountsPayable',
      key: 'NotAccountsPayable',
      indentStep: 1
    },
    {
      title: '其中:应付票据',
      dataIndex: 'NotesPayable',
      key: 'NotesPayable',
      indentStep: 1
    },
    {
      title: '应付账款',
      dataIndex: 'AccountsPayable',
      key: 'AccountsPayable',
      indentStep: 2
    },
    {
      title: '预收款项',
      dataIndex: 'AdvanceReceipts',
      key: 'AdvanceReceipts',
      indentStep: 1
    },
    {
      title: '合同负债',
      dataIndex: 'ContractLiability',
      key: 'ContractLiability',
      indentStep: 1
    },
    {
      title: '应付职工薪酬',
      dataIndex: 'SalariesPayable',
      key: 'SalariesPayable',
      indentStep: 1
    },
    {
      title: '应交税费',
      dataIndex: 'TaxsPayable',
      key: 'TaxsPayable',
      indentStep: 1
    },
    {
      title: '其他应付款合计',
      dataIndex: 'OtherPayableED',
      key: 'OtherPayableED',
      indentStep: 1
    },
    {
      title: '其中:应付股利',
      dataIndex: 'DividendPayable',
      key: 'DividendPayable',
      indentStep: 1
    },
    {
      title: '一年内到期的非流动负债',
      dataIndex: 'NonCurrentLiabilityIn1Year',
      key: 'NonCurrentLiabilityIn1Year',
      indentStep: 1
    },
    {
      title: '其他流动负债',
      dataIndex: 'OtherCurrentLiability',
      key: 'OtherCurrentLiability',
      indentStep: 1
    },
    {
      title: '流动负债合计',
      dataIndex: 'TotalCurrentLiability',
      key: 'TotalCurrentLiability'
    },
    {
      title: '非流动负债',
      dataIndex: '',
      key: ''
    },
    {
      title: '长期借款',
      dataIndex: 'LongtermLoan',
      key: 'LongtermLoan',
      indentStep: 1
    },
    {
      title: '应付债券',
      dataIndex: 'BondsPayable',
      key: 'BondsPayable',
      indentStep: 1
    },
    {
      title: '租赁负债',
      dataIndex: 'LeaseLiabilities',
      key: 'LeaseLiabilities',
      indentStep: 1
    },
    {
      title: '长期应付款',
      dataIndex: 'LongtermAccountPayable',
      key: 'LongtermAccountPayable',
      indentStep: 1
    },
    {
      title: '递延收益',
      dataIndex: 'LongDeferIncome',
      key: 'LongDeferIncome',
      indentStep: 1
    },
    {
      title: '递延所得税负债',
      dataIndex: 'DeferredTaxLiability',
      key: 'DeferredTaxLiability',
      indentStep: 1
    },
    {
      title: '非流动负债合计',
      dataIndex: 'TotalNonCurrentLiability',
      key: 'TotalNonCurrentLiability'
    },
    {
      title: '负债合计',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '所有者权益',
      dataIndex: '',
      key: ''
    },
    {
      title: '实收资本（或股本）',
      dataIndex: 'PaidInCapital',
      key: 'PaidInCapital',
      indentStep: 1
    },
    {
      title: '其他权益工具',
      dataIndex: 'OtherEquityinstruments',
      key: 'OtherEquityinstruments',
      indentStep: 1
    },
    {
      title: '资本公积',
      dataIndex: 'CapitalReserveFund',
      key: 'CapitalReserveFund',
      indentStep: 1
    },
    {
      title: '减:库存股',
      dataIndex: 'TreasuryStock',
      key: 'TreasuryStock',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome',
      indentStep: 1
    },
    {
      title: '盈余公积',
      dataIndex: 'SurplusReserveFund',
      key: 'SurplusReserveFund',
      indentStep: 1
    },
    {
      title: '未分配利润',
      dataIndex: 'RetainedProfit',
      key: 'RetainedProfit',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益合计',
      dataIndex: 'SEWithoutMI',
      key: 'SEWithoutMI'
    },
    {
      title: '少数股东权益',
      dataIndex: 'MinorityInterests',
      key: 'MinorityInterests',
      indentStep: 1
    },
    {
      title: '股东权益合计',
      dataIndex: 'TotalShareholderEquity',
      key: 'TotalShareholderEquity'
    },
    {
      title: '负债和股东权益合计',
      dataIndex: 'TotalLiabilityAndEquity',
      key: 'TotalLiabilityAndEquity'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType',
      indentStep: 1
    }
  ],
  bank: [
    {
      title: '资产负债表',
      dataIndex: 'time',
      key: 'time'
      // width: "100px",
      // fixed: "left",
    },
    {
      title: '资产',
      dataIndex: '',
      key: ''
      // width: "100px",
      // fixed: "left",
    },
    {
      title: '现金及存放中央银行款项',
      dataIndex: 'CashEquivalents',
      key: 'CashEquivalents',
      indentStep: 1
    },
    {
      title: '存放同业款项',
      dataIndex: 'DepositInInterbank',
      key: 'DepositInInterbank',
      indentStep: 1
    },
    {
      title: '贵金属',
      dataIndex: 'RMetal',
      key: 'RMetal',
      indentStep: 1
    },
    {
      title: '拆出资金',
      dataIndex: 'LendCapital',
      key: 'LendCapital',
      indentStep: 1
    },
    {
      title: '衍生金融资产',
      dataIndex: 'DerivativeAssets',
      key: 'DerivativeAssets',
      indentStep: 1
    },
    {
      title: '买入返售金融资产',
      dataIndex: 'BoughtSellbackAssets',
      key: 'BoughtSellbackAssets',
      indentStep: 1
    },
    {
      title: '发放贷款及垫款',
      dataIndex: 'LoanAndAdvance',
      key: 'LoanAndAdvance',
      indentStep: 1
    },
    {
      title: '交易性金融资产',
      dataIndex: 'TradingAssets',
      key: 'TradingAssets',
      indentStep: 1
    },
    {
      title: '债权投资',
      dataIndex: 'DebtInvestment',
      key: 'DebtInvestment',
      indentStep: 1
    },
    {
      title: '其他债权投资',
      dataIndex: 'OthDebtInvestment',
      key: 'OthDebtInvestment',
      indentStep: 1
    },
    {
      title: '其他权益工具投资',
      dataIndex: 'OthEquityInstrument',
      key: 'OthEquityInstrument',
      indentStep: 1
    },
    {
      title: '长期股权投资',
      dataIndex: 'LongtermEquityInvest',
      key: 'LongtermEquityInvest',
      indentStep: 1
    },
    {
      title: '固定资产',
      dataIndex: 'FixedAssets',
      key: 'FixedAssets',
      indentStep: 1
    },
    {
      title: '使用权资产',
      dataIndex: 'UsufructAssets',
      key: 'UsufructAssets',
      indentStep: 1
    },
    {
      title: '无形资产',
      dataIndex: 'IntangibleAssets',
      key: 'IntangibleAssets',
      indentStep: 1
    },
    {
      title: '商誉',
      dataIndex: 'GoodWill',
      key: 'GoodWill',
      indentStep: 1
    },
    {
      title: '递延所得税资产',
      dataIndex: 'DeferredTaxAssets',
      key: 'DeferredTaxAssets',
      indentStep: 1
    },
    {
      title: '其他资产',
      dataIndex: 'OtherAssets',
      key: 'OtherAssets',
      indentStep: 1
    },
    {
      title: '资产总计',
      dataIndex: 'TotalAssets',
      key: 'TotalAssets'
    },
    {
      title: '负债',
      dataIndex: '',
      key: ''
    },
    {
      title: '向中央银行借款',
      dataIndex: 'BorrowingFromCentralBank',
      key: 'BorrowingFromCentralBank',
      indentStep: 1
    },
    {
      title: '同业及其他金融机构存放款项',
      dataIndex: 'DepositOfInterbank',
      key: 'DepositOfInterbank',
      indentStep: 1
    },
    {
      title: '拆入资金',
      dataIndex: 'BorrowingCapital',
      key: 'BorrowingCapital',
      indentStep: 1
    },
    {
      title: '交易性金融负债',
      dataIndex: 'TradingLiability',
      key: 'TradingLiability',
      indentStep: 1
    },
    {
      title: '衍生金融负债',
      dataIndex: 'DerivativeLiability',
      key: 'DerivativeLiability',
      indentStep: 1
    },
    {
      title: '卖出回购金融资产款',
      dataIndex: 'SoldBuybackSecuProceeds',
      key: 'SoldBuybackSecuProceeds',
      indentStep: 1
    },
    {
      title: '吸收存款',
      dataIndex: 'Deposit',
      key: 'Deposit',
      indentStep: 1
    },
    {
      title: '应付职工薪酬',
      dataIndex: 'SalariesPayable',
      key: 'SalariesPayable',
      indentStep: 1
    },
    {
      title: '应交税费',
      dataIndex: 'TaxsPayable',
      key: 'TaxsPayable',
      indentStep: 1
    },
    {
      title: '预计负债',
      dataIndex: 'EstimateLiability',
      key: 'EstimateLiability',
      indentStep: 1
    },
    {
      title: '递延所得税负债',
      dataIndex: 'DeferredTaxLiability',
      key: 'DeferredTaxLiability',
      indentStep: 1
    },
    {
      title: '应付债券',
      dataIndex: 'BondsPayable',
      key: 'BondsPayable',
      indentStep: 1
    },
    {
      title: '租赁负债',
      dataIndex: 'LeaseLiabilities',
      key: 'LeaseLiabilities',
      indentStep: 1
    },
    {
      title: '其他负债',
      dataIndex: 'OtherLiability',
      key: 'OtherLiability',
      indentStep: 1
    },
    {
      title: '负债合计',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '所有者权益',
      dataIndex: '',
      key: ''
    },
    {
      title: '股本',
      dataIndex: 'PaidInCapital',
      key: 'PaidInCapital',
      indentStep: 1
    },
    {
      title: '其他权益工具',
      dataIndex: 'OtherEquityinstruments',
      key: 'OtherEquityinstruments',
      indentStep: 1
    },
    {
      title: '其中:优先股',
      dataIndex: 'EPreferStock',
      key: 'EPreferStock',
      indentStep: 1
    },
    {
      title: '永续债',
      dataIndex: 'EPerpetualDebt',
      key: 'EPerpetualDebt',
      indentStep: 2
    },
    {
      title: '资本公积',
      dataIndex: 'CapitalReserveFund',
      key: 'CapitalReserveFund',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome',
      indentStep: 1
    },
    {
      title: '盈余公积',
      dataIndex: 'SurplusReserveFund',
      key: 'SurplusReserveFund',
      indentStep: 1
    },
    {
      title: ' 一般风险准备',
      dataIndex: 'OrdinaryRiskReserveFund',
      key: 'OrdinaryRiskReserveFund',
      indentStep: 1
    },
    {
      title: '未分配利润',
      dataIndex: 'RetainedProfit',
      key: 'RetainedProfit',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益合计',
      dataIndex: 'SEWithoutMI',
      key: 'SEWithoutMI'
    },
    {
      title: '少数股东权益',
      dataIndex: 'MinorityInterests',
      key: 'MinorityInterests',
      indentStep: 1
    },
    {
      title: '股东权益合计',
      dataIndex: 'TotalShareholderEquity',
      key: 'TotalShareholderEquity'
    },
    {
      title: '负债和股东权益合计',
      dataIndex: 'TotalLiabilityAndEquity',
      key: 'TotalLiabilityAndEquity'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType',
      indentStep: 1
    }
  ],
  bond: [
    {
      title: '资产负债表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '资产',
      dataIndex: '',
      key: ''
    },
    {
      title: '货币资金',
      dataIndex: 'CashEquivalents',
      key: 'CashEquivalents',
      indentStep: 1
    },
    {
      title: '其中:客户资金存款',
      dataIndex: 'ClientDeposit',
      key: 'ClientDeposit',
      indentStep: 1
    },
    {
      title: '结算备付金',
      dataIndex: 'SettlementProvi',
      key: 'SettlementProvi',
      indentStep: 1
    },
    {
      title: '其中:客户备付金',
      dataIndex: 'ClientProvi',
      key: 'ClientProvi',
      indentStep: 1
    },
    {
      title: '融出资金',
      dataIndex: 'Financing',
      key: 'Financing',
      indentStep: 1
    },
    {
      title: '衍生金融资产',
      dataIndex: 'DerivativeAssets',
      key: 'DerivativeAssets',
      indentStep: 1
    },
    {
      title: '买入返售金融资产',
      dataIndex: 'BoughtSellbackAssets',
      key: 'BoughtSellbackAssets',
      indentStep: 1
    },
    {
      title: '应收款项',
      dataIndex: 'LoanAndAccountReceivables',
      key: 'LoanAndAccountReceivables',
      indentStep: 1
    },
    {
      title: '存出保证金',
      dataIndex: 'RefundableDeposit',
      key: 'RefundableDeposit',
      indentStep: 1
    },
    {
      title: '交易性金融资产',
      dataIndex: 'TradingAssets',
      key: 'TradingAssets',
      indentStep: 1
    },
    {
      title: '债权投资',
      dataIndex: 'DebtInvestment',
      key: 'DebtInvestment',
      indentStep: 1
    },
    {
      title: '其他债权投资',
      dataIndex: 'OthDebtInvestment',
      key: 'OthDebtInvestment',
      indentStep: 1
    },
    {
      title: '其他权益工具投资',
      dataIndex: 'OthEquityInstrument',
      key: 'OthEquityInstrument',
      indentStep: 1
    },
    {
      title: '长期股权投资',
      dataIndex: 'LongtermEquityInvest',
      key: 'LongtermEquityInvest',
      indentStep: 1
    },
    {
      title: '固定资产',
      dataIndex: 'FixedAssets',
      key: 'FixedAssets',
      indentStep: 1
    },
    {
      title: '使用权资产',
      dataIndex: 'UsufructAssets',
      key: 'UsufructAssets',
      indentStep: 1
    },
    {
      title: '无形资产',
      dataIndex: 'IntangibleAssets',
      key: 'IntangibleAssets',
      indentStep: 1
    },
    {
      title: '商誉',
      dataIndex: 'GoodWill',
      key: 'GoodWill',
      indentStep: 1
    },
    {
      title: '递延所得税资产',
      dataIndex: 'DeferredTaxAssets',
      key: 'DeferredTaxAssets',
      indentStep: 1
    },
    {
      title: '其他资产',
      dataIndex: 'OtherAssets',
      key: 'OtherAssets',
      indentStep: 1
    },
    {
      title: '资产总计',
      dataIndex: 'TotalAssets',
      key: 'TotalAssets'
    },
    {
      title: '负债',
      dataIndex: '',
      key: ''
    },
    {
      title: '短期借款',
      dataIndex: 'ShortTermLoan',
      key: 'ShortTermLoan',
      indentStep: 1
    },
    {
      title: '应付短期融资款',
      dataIndex: 'STBondsPayable',
      key: 'STBondsPayable',
      indentStep: 1
    },
    {
      title: '拆入资金',
      dataIndex: 'BorrowingCapital',
      key: 'BorrowingCapital',
      indentStep: 1
    },
    {
      title: '交易性金融负债',
      dataIndex: 'TradingLiability',
      key: 'TradingLiability',
      indentStep: 1
    },
    {
      title: '衍生金融负债',
      dataIndex: 'DerivativeLiability',
      key: 'DerivativeLiability',
      indentStep: 1
    },
    {
      title: '卖出回购金融资产款',
      dataIndex: 'SoldBuybackSecuProceeds',
      key: 'SoldBuybackSecuProceeds',
      indentStep: 1
    },
    {
      title: '代理买卖证券款',
      dataIndex: 'ProxySecuProceeds',
      key: 'ProxySecuProceeds',
      indentStep: 1
    },
    {
      title: '代理承销证券款',
      dataIndex: 'SubIssueSecuProceeds',
      key: 'SubIssueSecuProceeds',
      indentStep: 1
    },
    {
      title: '应付账款',
      dataIndex: 'AccountsPayable',
      key: 'AccountsPayable',
      indentStep: 1
    },
    {
      title: '应付职工薪酬',
      dataIndex: 'SalariesPayable',
      key: 'SalariesPayable',
      indentStep: 1
    },
    {
      title: '应交税费',
      dataIndex: 'TaxsPayable',
      key: 'TaxsPayable',
      indentStep: 1
    },
    {
      title: '应付债券',
      dataIndex: 'BondsPayable',
      key: 'BondsPayable',
      indentStep: 1
    },
    {
      title: '租赁负债',
      dataIndex: 'LeaseLiabilities',
      key: 'LeaseLiabilities',
      indentStep: 1
    },
    {
      title: '递延所得税负债',
      dataIndex: 'DeferredTaxLiability',
      key: 'DeferredTaxLiability',
      indentStep: 1
    },
    {
      title: '其他负债',
      dataIndex: 'OtherLiability',
      key: 'OtherLiability',
      indentStep: 1
    },
    {
      title: '负债合计',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '所有者权益',
      dataIndex: '',
      key: ''
    },
    {
      title: '股本',
      dataIndex: 'PaidInCapital',
      key: 'PaidInCapital',
      indentStep: 1
    },
    {
      title: '资本公积',
      dataIndex: 'CapitalReserveFund',
      key: 'CapitalReserveFund',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome',
      indentStep: 1
    },
    {
      title: '盈余公积',
      dataIndex: 'SurplusReserveFund',
      key: 'SurplusReserveFund',
      indentStep: 1
    },
    {
      title: ' 一般风险准备',
      dataIndex: 'OrdinaryRiskReserveFund',
      key: 'OrdinaryRiskReserveFund',
      indentStep: 1
    },
    {
      title: '未分配利润',
      dataIndex: 'RetainedProfit',
      key: 'RetainedProfit',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益合计',
      dataIndex: 'SEWithoutMI',
      key: 'SEWithoutMI'
    },
    {
      title: '  少数股东权益',
      dataIndex: 'MinorityInterests',
      key: 'MinorityInterests',
      indentStep: 1
    },
    {
      title: '股东权益合计',
      dataIndex: 'TotalShareholderEquity',
      key: 'TotalShareholderEquity'
    },
    {
      title: '负债和股东权益合计',
      dataIndex: 'TotalLiabilityAndEquity',
      key: 'TotalLiabilityAndEquity'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType',
      indentStep: 1
    }
  ],
  insurance: [
    {
      title: '资产负债表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '资产',
      dataIndex: '',
      key: ''
    },
    {
      title: '货币资金',
      dataIndex: 'CashEquivalents',
      key: 'CashEquivalents',
      indentStep: 1
    },
    {
      title: '以公允价值计量且其变动计入当期损益的金融资产',
      dataIndex: '',
      key: '',
      indentStep: 1
    },
    {
      title: '买入返售金融资产',
      dataIndex: 'BoughtSellbackAssets',
      key: 'BoughtSellbackAssets',
      indentStep: 1
    },
    {
      title: '应收利息',
      dataIndex: 'InterestReceivable',
      key: 'InterestReceivable',
      indentStep: 1
    },
    {
      title: '应收保费',
      dataIndex: 'InsuranceReceivables',
      key: 'InsuranceReceivables',
      indentStep: 1
    },
    {
      title: '应收分保账款',
      dataIndex: 'ReinsuranceReceivables',
      key: 'ReinsuranceReceivables',
      indentStep: 1
    },
    {
      title: '应收分保合同准备金',
      dataIndex: 'ResReiReceContracts',
      key: 'ResReiReceContracts',
      indentStep: 1
    },
    {
      title: '其中:应收分保未到期责任准备金',
      dataIndex: 'ReceivableUnearnedR',
      key: 'ReceivableUnearnedR',
      indentStep: 1
    },
    {
      title: '应收分保未决赔偿准备金',
      dataIndex: 'ReceivableClaimsR',
      key: 'ReceivableClaimsR',
      indentStep: 2
    },
    {
      title: '应收分保寿险责任准备金',
      dataIndex: 'ReceivableLifeR',
      key: 'ReceivableLifeR',
      indentStep: 2
    },
    {
      title: '应收分保长期健康险责任准备金',
      dataIndex: 'ReceivableLTHealthR',
      key: 'ReceivableLTHealthR',
      indentStep: 2
    },
    {
      title: '发放贷款及垫款',
      dataIndex: 'LoanAndAdvance',
      key: 'LoanAndAdvance',
      indentStep: 1
    },
    {
      title: '其他应收款',
      dataIndex: 'OtherReceivable',
      key: 'OtherReceivable',
      indentStep: 1
    },
    {
      title: '定期存款',
      dataIndex: 'FixedDeposit',
      key: 'FixedDeposit',
      indentStep: 1
    },
    {
      title: '可供出售金融资产',
      dataIndex: 'HoldForSaleAssets',
      key: 'HoldForSaleAssets',
      indentStep: 1
    },
    {
      title: '持有至到期投资',
      dataIndex: 'AFAverageHoldSumChange',
      key: 'AFAverageHoldSumChange',
      indentStep: 1
    },
    {
      title: '长期股权投资',
      dataIndex: 'HoldToMaturityInvestments',
      key: 'HoldToMaturityInvestments',
      indentStep: 1
    },
    {
      title: '存出资本保证金',
      dataIndex: 'RefundableCapitalDeposit',
      key: 'RefundableCapitalDeposit',
      indentStep: 1
    },
    {
      title: '投资性房地产',
      dataIndex: 'InvestmentProperty',
      key: 'InvestmentProperty',
      indentStep: 1
    },
    {
      title: '固定资产',
      dataIndex: 'FixedAssets',
      key: 'FixedAssets',
      indentStep: 1
    },
    {
      title: '在建工程',
      dataIndex: 'ConstruInProcess',
      key: 'ConstruInProcess',
      indentStep: 1
    },
    {
      title: '使用权资产',
      dataIndex: 'UsufructAssets',
      key: 'UsufructAssets',
      indentStep: 1
    },
    {
      title: '无形资产',
      dataIndex: 'IntangibleAssets',
      key: 'IntangibleAssets',
      indentStep: 1
    },
    {
      title: '递延所得税资产',
      dataIndex: 'DeferredTaxAssets',
      key: 'DeferredTaxAssets',
      indentStep: 1
    },
    {
      title: '其他资产',
      dataIndex: 'OtherAssets',
      key: 'OtherAssets',
      indentStep: 1
    },
    {
      title: '独立账户资产',
      dataIndex: 'IndependenceAccountAssets',
      key: 'IndependenceAccountAssets',
      indentStep: 1
    },
    {
      title: '资产总计',
      dataIndex: 'TotalAssets',
      key: 'TotalAssets'
    },
    {
      title: '负债',
      dataIndex: '',
      key: ''
    },
    {
      title: '短期借款',
      dataIndex: 'ShortTermLoan',
      key: 'ShortTermLoan',
      indentStep: 1
    },
    {
      title: '以公允价值计量且其变动计入当期损益的金融负债',
      dataIndex: '',
      key: '',
      indentStep: 1
    },
    {
      title: '卖出回购金融资产款',
      dataIndex: 'SoldBuybackSecuProceeds',
      key: 'SoldBuybackSecuProceeds',
      indentStep: 1
    },
    {
      title: '预收保费',
      dataIndex: 'AdvanceInsurance',
      key: 'AdvanceInsurance',
      indentStep: 1
    },
    {
      title: '应付手续费及佣金',
      dataIndex: 'CommissionPayable',
      key: 'CommissionPayable',
      indentStep: 1
    },
    {
      title: '应付分保账款',
      dataIndex: 'ReinsurancePayables',
      key: 'ReinsurancePayables',
      indentStep: 1
    },
    {
      title: '应付职工薪酬',
      dataIndex: 'SalariesPayable',
      key: 'SalariesPayable',
      indentStep: 1
    },
    {
      title: '应交税费',
      dataIndex: 'TaxsPayable',
      key: 'TaxsPayable',
      indentStep: 1
    },
    {
      title: '应付股利',
      dataIndex: 'DividendPayable',
      key: 'DividendPayable',
      indentStep: 1
    },
    {
      title: '应付赔偿款',
      dataIndex: 'CompensationPayable',
      key: 'CompensationPayable',
      indentStep: 1
    },
    {
      title: '应付保单红利',
      dataIndex: 'PolicyDividendPayable',
      key: 'PolicyDividendPayable',
      indentStep: 1
    },
    {
      title: '其他应付款',
      dataIndex: 'OtherPayableED',
      key: 'OtherPayableED',
      indentStep: 1
    },
    {
      title: '保户储金及投资款',
      dataIndex: 'InsurerDepositInvestment',
      key: 'InsurerDepositInvestment',
      indentStep: 1
    },
    {
      title: '保险合同准备金',
      dataIndex: 'InsContractReserve',
      key: 'InsContractReserve',
      indentStep: 1
    },
    {
      title: '其中:未到期责任准备金',
      dataIndex: 'UnearnedPremiumReserve',
      key: 'UnearnedPremiumReserve',
      indentStep: 1
    },
    {
      title: '未决赔款准备金',
      dataIndex: 'OutstandingClaimReserve',
      key: 'OutstandingClaimReserve',
      indentStep: 1
    },
    {
      title: '寿险责任准备金',
      dataIndex: 'LifeInsuranceReserve',
      key: 'LifeInsuranceReserve',
      indentStep: 1
    },
    {
      title: '长期健康险责任准备金',
      dataIndex: 'LTHealthInsuranceLR',
      key: 'LTHealthInsuranceLR',
      indentStep: 1
    },
    {
      title: '长期借款',
      dataIndex: 'LongtermLoan',
      key: 'LongtermLoan',
      indentStep: 1
    },
    {
      title: '应付债券',
      dataIndex: 'BondsPayable',
      key: 'BondsPayable',
      indentStep: 1
    },
    {
      title: '租赁负债',
      dataIndex: 'LeaseLiabilities',
      key: 'LeaseLiabilities',
      indentStep: 1
    },
    {
      title: '递延所得税负债',
      dataIndex: 'DeferredTaxLiability',
      key: 'DeferredTaxLiability',
      indentStep: 1
    },
    {
      title: '其他负债',
      dataIndex: 'OtherLiability',
      key: 'OtherLiability',
      indentStep: 1
    },
    {
      title: '独立账户负债',
      dataIndex: 'IndependenceLiability',
      key: 'IndependenceLiability',
      indentStep: 1
    },
    {
      title: '负债合计',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '所有者权益',
      dataIndex: '',
      key: ''
    },
    {
      title: '股本',
      dataIndex: 'PaidInCapital',
      key: 'PaidInCapital',
      indentStep: 1
    },
    {
      title: '其他权益工具',
      dataIndex: 'OtherEquityinstruments',
      key: 'OtherEquityinstruments',
      indentStep: 1
    },
    {
      title: '资本公积',
      dataIndex: 'CapitalReserveFund',
      key: 'CapitalReserveFund',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome',
      indentStep: 1
    },
    {
      title: '盈余公积',
      dataIndex: 'SurplusReserveFund',
      key: 'SurplusReserveFund',
      indentStep: 1
    },
    {
      title: '一般风险准备',
      dataIndex: 'OrdinaryRiskReserveFund',
      key: 'OrdinaryRiskReserveFund',
      indentStep: 1
    },
    {
      title: '未分配利润',
      dataIndex: 'RetainedProfit',
      key: 'RetainedProfit',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益合计',
      dataIndex: 'SEWithoutMI',
      key: 'SEWithoutMI'
    },
    {
      title: '少数股东权益',
      dataIndex: 'MinorityInterests',
      key: 'MinorityInterests',
      indentStep: 1
    },
    {
      title: '股东权益合计',
      dataIndex: 'TotalShareholderEquity',
      key: 'TotalShareholderEquity'
    },
    {
      title: '负债和股东权益合计',
      dataIndex: 'TotalLiabilityAndEquity',
      key: 'TotalLiabilityAndEquity'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType',
      indentStep: 1
    }
  ],
  trust: [
    {
      title: '资产负债表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '资产',
      dataIndex: '',
      key: ''
    },
    {
      title: '现金及存放中央银行款项',
      dataIndex: 'CashEquivalents',
      key: 'CashEquivalents',
      indentStep: 1
    },
    {
      title: '买入返售金融资产',
      dataIndex: 'BoughtSellbackAssets',
      key: 'BoughtSellbackAssets',
      indentStep: 1
    },
    {
      title: '发放贷款及垫款',
      dataIndex: 'LoanAndAdvance',
      key: 'LoanAndAdvance',
      indentStep: 1
    },
    {
      title: '交易性金融资产',
      dataIndex: 'TradingAssets',
      key: 'TradingAssets',
      indentStep: 1
    },
    {
      title: '债权投资',
      dataIndex: 'DebtInvestment',
      key: 'DebtInvestment',
      indentStep: 1
    },
    {
      title: '其他权益工具投资',
      dataIndex: 'OthEquityInstrument',
      key: 'OthEquityInstrument',
      indentStep: 1
    },
    {
      title: '持有待售资产',
      dataIndex: 'HoldAndFSAssets',
      key: 'HoldAndFSAssets',
      indentStep: 1
    },
    {
      title: '长期股权投资',
      dataIndex: 'LongtermEquityInvest',
      key: 'LongtermEquityInvest',
      indentStep: 1
    },
    {
      title: '固定资产',
      dataIndex: 'FixedAssets',
      key: 'FixedAssets',
      indentStep: 1
    },
    {
      title: '使用权资产',
      dataIndex: 'UsufructAssets',
      key: 'UsufructAssets',
      indentStep: 1
    },
    {
      title: '无形资产',
      dataIndex: 'IntangibleAssets',
      key: 'IntangibleAssets',
      indentStep: 1
    },
    {
      title: '递延所得税资产',
      dataIndex: 'DeferredTaxAssets',
      key: 'DeferredTaxAssets',
      indentStep: 1
    },
    {
      title: '其他资产',
      dataIndex: 'OtherAssets',
      key: 'OtherAssets',
      indentStep: 1
    },
    {
      title: '资产总计',
      dataIndex: 'TotalAssets',
      key: 'TotalAssets'
    },
    {
      title: '负债',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '应付职工薪酬',
      dataIndex: 'SalariesPayable',
      key: 'SalariesPayable',
      indentStep: 1
    },
    {
      title: '应交税费',
      dataIndex: 'TaxsPayable',
      key: 'TaxsPayable',
      indentStep: 1
    },
    {
      title: '递延所得税负债',
      dataIndex: 'DeferredTaxLiability',
      key: 'DeferredTaxLiability',
      indentStep: 1
    },
    {
      title: '租赁负债',
      dataIndex: 'LeaseLiabilities',
      key: 'LeaseLiabilities',
      indentStep: 1
    },
    {
      title: '其他负债',
      dataIndex: 'OtherLiability',
      key: 'OtherLiability',
      indentStep: 1
    },
    {
      title: '负债合计',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '所有者权益',
      dataIndex: '',
      key: ''
    },
    {
      title: '股本',
      dataIndex: 'PaidInCapital',
      key: 'PaidInCapital',
      indentStep: 1
    },
    {
      title: '资本公积',
      dataIndex: 'CapitalReserveFund',
      key: 'CapitalReserveFund',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome',
      indentStep: 1
    },
    {
      title: '盈余公积',
      dataIndex: 'SurplusReserveFund',
      key: 'SurplusReserveFund',
      indentStep: 1
    },
    {
      title: '一般风险准备',
      dataIndex: 'OrdinaryRiskReserveFund',
      key: 'OrdinaryRiskReserveFund',
      indentStep: 1
    },
    {
      title: '未分配利润',
      dataIndex: 'RetainedProfit',
      key: 'RetainedProfit',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益其他项目',
      dataIndex: 'SEExceptionalItems',
      key: 'SEExceptionalItems',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益合计',
      dataIndex: 'SEWithoutMI',
      key: 'SEWithoutMI'
    },
    {
      title: '少数股东权益',
      dataIndex: 'MinorityInterests',
      key: 'MinorityInterests',
      indentStep: 1
    },
    {
      title: '股东权益合计',
      dataIndex: 'TotalShareholderEquity',
      key: 'TotalShareholderEquity'
    },
    {
      title: '负债和股东权益合计',
      dataIndex: 'TotalLiabilityAndEquity',
      key: 'TotalLiabilityAndEquity'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType',
      indentStep: 1
    }
  ],
  others: [
    {
      title: '资产负债表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '资产',
      dataIndex: '',
      key: ''
    },
    {
      title: '货币资金',
      dataIndex: 'CashEquivalents',
      key: 'CashEquivalents',
      indentStep: 1
    },
    {
      title: '其中:客户信用资金存款',
      dataIndex: 'ClientDeposit',
      key: 'ClientDeposit',
      indentStep: 1
    },
    {
      title: '衍生金融资产',
      dataIndex: 'DerivativeAssets',
      key: 'DerivativeAssets',
      indentStep: 1
    },
    {
      title: '应收款项',
      dataIndex: 'LoanAndAccountReceivables',
      key: 'LoanAndAccountReceivables',
      indentStep: 1
    },
    {
      title: '交易性金融资产',
      dataIndex: 'TradingAssets',
      key: 'TradingAssets',
      indentStep: 1
    },
    {
      title: '长期股权投资',
      dataIndex: 'LongtermEquityInvest',
      key: 'LongtermEquityInvest',
      indentStep: 1
    },
    {
      title: '投资性房地产',
      dataIndex: 'InvestmentProperty',
      key: 'InvestmentProperty',
      indentStep: 1
    },
    {
      title: '固定资产',
      dataIndex: 'FixedAssets',
      key: 'FixedAssets',
      indentStep: 1
    },
    {
      title: '在建工程',
      dataIndex: 'ConstruInProcess',
      key: 'ConstruInProcess',
      indentStep: 1
    },
    {
      title: '使用权资产',
      dataIndex: 'UsufructAssets',
      key: 'UsufructAssets',
      indentStep: 1
    },
    {
      title: '无形资产',
      dataIndex: 'IntangibleAssets',
      key: 'IntangibleAssets',
      indentStep: 1
    },
    {
      title: '商誉',
      dataIndex: 'GoodWill',
      key: 'GoodWill',
      indentStep: 1
    },
    {
      title: '递延所得税资产',
      dataIndex: 'DeferredTaxAssets',
      key: 'DeferredTaxAssets',
      indentStep: 1
    },
    {
      title: '其他资产',
      dataIndex: 'OtherAssets',
      key: 'OtherAssets',
      indentStep: 1
    },
    {
      title: '资产总计',
      dataIndex: 'TotalAssets',
      key: 'TotalAssets'
    },
    {
      title: '负债',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '交易性金融负债',
      dataIndex: 'TradingLiability',
      key: 'TradingLiability',
      indentStep: 1
    },
    {
      title: '衍生金融负债',
      dataIndex: 'DerivativeLiability',
      key: 'DerivativeLiability',
      indentStep: 1
    },
    {
      title: '应付职工薪酬',
      dataIndex: 'SalariesPayable',
      key: 'SalariesPayable',
      indentStep: 1
    },
    {
      title: '应交税费',
      dataIndex: 'TaxsPayable',
      key: 'TaxsPayable',
      indentStep: 1
    },
    {
      title: '长期借款',
      dataIndex: 'LongtermLoan',
      key: 'LongtermLoan',
      indentStep: 1
    },
    {
      title: '应付债券',
      dataIndex: 'BondsPayable',
      key: 'BondsPayable',
      indentStep: 1
    },
    {
      title: '租赁负债',
      dataIndex: 'LeaseLiabilities',
      key: 'LeaseLiabilities',
      indentStep: 1
    },
    {
      title: '递延所得税负债',
      dataIndex: 'DeferredTaxLiability',
      key: 'DeferredTaxLiability',
      indentStep: 1
    },
    {
      title: '其他负债',
      dataIndex: 'OtherLiability',
      key: 'OtherLiability',
      indentStep: 1
    },
    {
      title: '负债合计',
      dataIndex: 'TotalLiability',
      key: 'TotalLiability'
    },
    {
      title: '所有者权益',
      dataIndex: '',
      key: ''
    },
    {
      title: '股本',
      dataIndex: 'PaidInCapital',
      key: 'PaidInCapital',
      indentStep: 1
    },
    {
      title: '其他权益工具',
      dataIndex: 'OtherEquityinstruments',
      key: 'OtherEquityinstruments',
      indentStep: 1
    },
    {
      title: '资本公积',
      dataIndex: 'CapitalReserveFund',
      key: 'CapitalReserveFund',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome',
      indentStep: 1
    },
    {
      title: '盈余公积',
      dataIndex: 'SurplusReserveFund',
      key: 'SurplusReserveFund',
      indentStep: 1
    },
    {
      title: '一般风险准备',
      dataIndex: 'OrdinaryRiskReserveFund',
      key: 'OrdinaryRiskReserveFund',
      indentStep: 1
    },
    {
      title: '未分配利润',
      dataIndex: 'RetainedProfit',
      key: 'RetainedProfit',
      indentStep: 1
    },
    {
      title: '归属于母公司股东权益合计',
      dataIndex: 'SEWithoutMI',
      key: 'SEWithoutMI'
    },
    {
      title: '少数股东权益',
      dataIndex: 'MinorityInterests',
      key: 'MinorityInterests',
      indentStep: 1
    },
    {
      title: '股东权益合计',
      dataIndex: 'TotalShareholderEquity',
      key: 'TotalShareholderEquity'
    },
    {
      title: '负债和股东权益合计',
      dataIndex: 'TotalLiabilityAndEquity',
      key: 'TotalLiabilityAndEquity'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType',
      indentStep: 1
    }
  ]
}

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata, DoubleRightOutlined, DoubleLeftOutlined },
  setup(props, context) {
    const myTableBlock = ref(HTMLElement)
    const scrollTable = ref(HTMLElement)
    const tooltip: any = reactive({})
    const overflow: any = reactive({})
    const pageData: any = reactive({
      data: [],
      columns: [],
      tags: [],
      activeTagVal: 1,
      classification: 'ybqy',
      noDataTitle: '',
      spinning: true,
      leftIconShow: false,
      rightIconShow: true,
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      timer: null
    })
    function handleScroll() {
      if ((pageData.data || []).length === 0) return
      const position = (myTableBlock.value as any).scrollLeft
      const clientW = (scrollTable.value as any).childNodes[1].clientWidth
      const target = clientW - 769
      pageData.leftIconShow = position > 0 ? true : false
      pageData.rightIconShow = position >= target ? false : true
    }
    watch(
      () => props.pageSourceData || {},
      (val: any) => {
        switch (val.EnterpriseType) {
          case 99:
            pageData.classification = 'ybqy'
            break
          case 13:
            pageData.classification = 'bank'
            break
          case 31:
            pageData.classification = 'bond'
            break
          case 33:
            pageData.classification = 'trust'
            break
          case 35:
            pageData.classification = 'insurance'
            break
          case 39:
            pageData.classification = 'others'
            break
          default:
        }
        const data = JSON.parse(JSON.stringify(val.Debt))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          pageData.data = data
        }
        nextTick(() => {
          pageData.spinning = false
          if ((pageData.data || []).length === 0) return
          const blockEl: any = myTableBlock.value
          blockEl.scrollLeft = 0
          handleScroll()
        })
      },
      { deep: true }
    )
    pageData.noDataTitle = computed(() => {
      const res = pageData.tags.find((item: any) => {
        return item.value === pageData.activeTagVal
      })
      return res.label
    })
    pageData.tags = [
      {
        label: '按报告期',
        value: 1
      },
      {
        label: '按年度',
        value: 2
      },
      {
        label: '报告期同比',
        value: 4
      },
      {
        label: '年度同比',
        value: 5
      }
    ]
    pageData.columns = computed(() => {
      return myColumns[pageData.classification]
    })

    async function checkTag(tag: any) {
      pageData.activeTagVal = tag.value
      pageData.data = await getDetail(pageData.activeTagVal)
      nextTick(() => {
        if ((pageData.data || []).length === 0) return
        const blockEl: any = myTableBlock.value
        blockEl.scrollLeft = 0
        handleScroll()
      })
    }
    const route = useRoute()
    function getDetail(type: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        StaticsType: type,
        DataType: 8
      }
      data.headers = {
        token: props.token
      }
      return f10Api.getFinanceF10(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify((res.Data || {}).Debt))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          // pageData.data = data
        }
        return data
      })
    }
    function scrollToTarget(direction: string) {
      const el: any = scrollTable.value
      const blockEl: any = myTableBlock.value
      const trWidth = (el.childNodes[1] as any).clientWidth // 一行的宽度
      const screenWidth = 1000 - 232 // 1屏
      const columWidth = trWidth / pageData.data.length // 1列
      const originPosition = blockEl.scrollLeft // 原始位置
      const step = screenWidth - columWidth // 每次滚动的距离=1屏-1列
      if (direction === 'left') {
        animateScroll(-step, blockEl)
      } else {
        animateScroll(step, blockEl)
      }
    }
    function animateScroll(step: number, blockEl: any) {
      const target = blockEl.scrollLeft + step
      clearInterval(pageData.timer)
      pageData.timer = setInterval(() => {
        let miniStep = step / 10
        miniStep = miniStep > 0 ? Math.ceil(step) : Math.floor(step)
        if (blockEl.scrollLeft + miniStep < target) {
          blockEl.scrollLeft += miniStep
        } else {
          blockEl.scrollLeft = target
          clearInterval(pageData.timer)
          pageData.timer = null
        }
      }, 20)
    }
    function getOpinion(val: any) {
      let res
      switch (val) {
        case 1:
          res = '无保留'
          break
        case 2:
          res = '无保留带解释性说明'
          break
        case 3:
          res = '保留意见'
          break
        case 4:
          res = '拒绝/无法表示意见'
          break
        case 5:
          res = '否定意见'
          break
        case 6:
          res = '未经审计'
          break
        case 7:
          res = '保留带解释性说明'
          break
        case 10:
          res = '经审计（不确定具体意见类型）'
          break
        default:
          res = '—'
      }
      return res
    }
    let timer: any = null
    function isoverflow(e: any, key: any, t: any) {
      tooltip[key + t] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (tooltip[key + t]) {
        if (!timer) {
          timer = setTimeout(() => {
            overflow[key + t] = true
          }, 400)
        }
      }
    }
    function hidetool(key: any, t: any) {
      if (timer) {
        setTimeout(() => {
          overflow[key + t] = false
          window.clearTimeout(timer)
          timer = null
        })
      }
    }
    return {
      ...toRefs(pageData),
      tooltip,
      overflow,
      isoverflow,
      hidetool,
      checkTag,
      myTableBlock,
      scrollTable,
      scrollToTarget,
      handleScroll,
      getOpinion
    }
  }
})
